import { getSetupFiles, name } from './extension.utils';
import { arrayify } from './helpers/utils';
import type { Plugin } from './types';

export const setupFs = (..._setupFiles: string[]): Plugin => {
  return {
    name,
    enforce: 'pre',
    config: async options => {
      const testConfig = options?.test;
      const prevSetupFiles = arrayify(testConfig?.setupFiles);

      const setupFiles = await getSetupFiles(prevSetupFiles, _setupFiles);

      return {
        ...options,
        test: {
          ...testConfig,
          setupFiles,
        },
      };
    },
  };
};
